export const resetShortcutObj = () => {
  return {
    type: 'RESET_SHORTCUT_OBJ',
    payload: {},
  }
}
export const resetShortcutStatus = (reset) => {
  return {
    type: 'RESET_SHORTCUT_STATUS',
    payload: reset,
  }
}

export const shortcutError = (error) => {
  return {
    type: 'SHORTCUT_ERROR',
    payload: error,
  }
}

export const getShortcuts = (data) => {
  return {
    type: 'GET_SHORTCUTS',
    payload: data,
  }
}
export const setShortcuts = (data) => {
  return {
    type: 'SET_SHORTCUTS',
    payload: data,
  }
}

export const addShortcut = (data) => {
  return {
    type: 'ADD_SHORTCUT',
    payload: data,
  }
}
export const addedShortcut = (data, message) => {
  return {
    type: 'ADDED_SHORTCUT',
    payload: { data, message },
  }
}

export const updateShortcut = (data) => {
  return {
    type: 'UPDATE_SHORTCUT',
    payload: data,
  }
}
export const updatedShortcut = (data) => {
  return {
    type: 'UPDATED_SHORTCUT',
    payload: data,
  }
}

export const deleteShortcut = (id) => {
  return {
    type: 'DELETE_SHORTCUT',
    payload: id,
  }
}
export const deletedShortcut = (id, message) => {
  return {
    type: 'DELETED_SHORTCUT',
    payload: { id, message },
  }
}
